module.exports = __webpack_public_path__ + "static/sanket-19861ae89ec5fc80685ea6d11db5a18a.webp";